<template>
  <v-overlay id="subscription-blocker" class="text-center" absolute>
    <v-row>
      <v-col cols="12">
        <v-card class="p-subs-card rounded pa-4 pa-md-6 mb-4 mb-md-6">
          <v-icon class="p-subs-icon mb-4">mdi-star-settings</v-icon>
          <p class="g-text-color-primary g-bold g-heading-s mb-3">
            PREMIUM FEATURE
          </p>
          <p class="g-text-color-black">
            Upgrade your plan to access more benefits
          </p>
          <br />
          <v-btn
            raised
            large
            rounded
            class="i-btn-block-secondary p-subs-btn"
            :to="{ name: 'subscription' }"
          >
            <strong>Subscriptions</strong>
          </v-btn>
        </v-card>
      </v-col>
    </v-row>
  </v-overlay>
</template>

<script></script>

<style lang="scss" scoped>
@import '@/styles/_variables.scss';

#subscription-blocker {
  .p-subs-btn {
    background-color: $secondary-color;
    color: white;
    font-size: 14px;
    font-weight: bold;
    letter-spacing: 0.75px;
    text-transform: none;
    width: 200px;
  }
  .p-subs-card {
    background-color: white;
    width: 90%;
    max-width: 360px;
    margin: auto;
  }
  .p-subs-icon {
    color: $secondary-color;
    &:before {
      font-size: 32px;
    }
  }
}

@media only screen and (min-width: 960px) {
  #subscription-blocker {
    .p-subs-btn {
      font-size: 16px;
      width: 250px;
    }
    .p-subs-card {
      min-width: 450px;
    }
    .p-subs-icon:before {
      font-size: 64px;
    }
  }
}
</style>
